document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const headerStack = document.querySelector('.storefront-header-stack');
if (headerStack) {
  let headerHeight = 0;
  const syncHeaderHeight = () => {
    const nextHeight = Math.ceil(headerStack.getBoundingClientRect().height);
    if (nextHeight > 0 && nextHeight !== headerHeight) {
      headerHeight = nextHeight;
      document.documentElement.style.setProperty('--storefront-header-height', `${nextHeight}px`);
    }
  };
  syncHeaderHeight();
  if ('ResizeObserver' in window) new ResizeObserver(syncHeaderHeight).observe(headerStack);
  else window.addEventListener('resize', syncHeaderHeight, { passive: true });
}

document.querySelectorAll('[data-faq-page]').forEach((page) => {
  const search = page.querySelector('[data-faq-search]');
  const count = page.querySelector('[data-faq-count]');
  const empty = page.querySelector('[data-faq-empty]');
  const items = Array.from(page.querySelectorAll('[data-faq-item]'));
  const topics = Array.from(page.querySelectorAll('[data-faq-topic]'));
  let activeTopic = 'all';

  const update = () => {
    const query = search?.value.trim().toLowerCase() || '';
    let matches = 0;
    items.forEach((item) => {
      const topicMatches = activeTopic === 'all' || item.dataset.faqCategory === activeTopic;
      const copyMatches = !query || (item.dataset.faqCopy || '').toLowerCase().includes(query);
      item.hidden = !(topicMatches && copyMatches);
      if (!item.hidden) matches += 1;
    });
    if (count) count.textContent = `${matches} ${matches === 1 ? 'question' : 'questions'}`;
    if (empty) empty.hidden = matches !== 0;
  };

  topics.forEach((topic) => topic.addEventListener('click', () => {
    activeTopic = topic.dataset.faqTopic || 'all';
    topics.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === topic)));
    update();
  }));
  search?.addEventListener('input', update);
  page.querySelector('[data-faq-reset]')?.addEventListener('click', () => {
    activeTopic = 'all';
    if (search) search.value = '';
    topics.forEach((topic) => topic.setAttribute('aria-pressed', String(topic.dataset.faqTopic === 'all')));
    update();
    search?.focus();
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('.mobile-menu-button[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});

// Keep the native details menu, including its no-JavaScript behavior.
document.querySelectorAll('.mobile-menu-button').forEach((menu) => {
  const close = (restoreFocus = false) => {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary')?.focus();
  };
  menu.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !menu.open) return;
    event.preventDefault();
    close(true);
  });
  menu.addEventListener('focusout', (event) => {
    if (event.relatedTarget && !menu.contains(event.relatedTarget)) close();
  });
  menu.addEventListener('click', (event) => {
    if (event.target.closest('.mobile-menu a')) close();
  });
});
